module.exports = __webpack_public_path__ + "img/compact.47e42e03.png";